import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MyPropertiesComponent } from './components/my-properties/my-properties.component';
import { SignInComponent } from './components/sign-in/sign-in.component';
import { SignUpOptionsComponent } from './components/sign-up-options/sign-up-options.component';
import { PropertyComponent } from './components/property/property.component';
import { AuthGuard } from './guards/auth.guard';
import { SignGuard } from './guards/sign.guard';
import { SignUpComponent } from './components/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SettingsComponent } from './components/settings/settings.component';

const routes: Routes = [
  {
    path: 'sign-in',
    component: SignInComponent,
    canActivate: [SignGuard],
  },
  {
    path: 'sign-up',
    component: SignUpComponent,
    canActivate: [SignGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [SignGuard],
  },
  {
    path: 'sign-up-options',
    component: SignUpOptionsComponent,
    canActivate: [SignGuard],
  },
  {
    path: 'my-properties',
    component: MyPropertiesComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'add-property',
    component: PropertyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'edit-property/:id',
    component: PropertyComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'settings',
    component: SettingsComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'sign-in',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {}
